import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Carousel, CarouselVariant, CarouselPaginationVariant, SliderNavVariant, SliderNavColor, IconSize, } from '@as/cotopaxi';
import { MAX_SCREEN_WIDTH_TABLET, MAX_SCREEN_WIDTH_TABLET_SMALL, MIN_SCREEN_WIDTH_DESKTOP, MIN_SCREEN_WIDTH_DESKTOP_LARGE, MIN_SCREEN_WIDTH_MOBILE_LARGE, MIN_SCREEN_WIDTH_TABLET, MIN_SCREEN_WIDTH_TABLET_SMALL, MIN_SCREEN_WIDTH_MOBILE, } from '../../constants/ScreenWidthConstants';
import { SLIDE_SPACING, SlideCropped } from '../../constants/SliderConstants';
import { HtmlInclude } from '../common/html-include/HtmlInclude';
export const Slider = ({ children, height, fullWidth, id, properties: { autoplay, displayCroppedSlides, hideOnViewports, infiniteSliding, innerSpacing, showArrowsForDesktop, showIndicators, slidesToScrollDesktop, slidesToScrollDesktopLarge, slidesToScrollMobile, slidesToScrollMobileLarge, slidesToScrollTablet, slidesToScrollTabletSmall, slidesToShowDesktop, slidesToShowDesktopLarge, slidesToShowMobile, slidesToShowMobileLarge, slidesToShowTablet, slidesToShowTabletSmall, }, }) => {
    const slidesSpacing = innerSpacing ? SLIDE_SPACING.MOBILE : 0;
    const breakpoints = {
        [MIN_SCREEN_WIDTH_MOBILE]: {
            slidesPerView: displayCroppedSlides ? slidesToShowMobile + SlideCropped.SMALL : slidesToShowMobile,
            slidesPerGroup: slidesToScrollMobile,
        },
        [MIN_SCREEN_WIDTH_MOBILE_LARGE]: {
            slidesPerView: displayCroppedSlides ? slidesToShowMobileLarge + SlideCropped.SMALL : slidesToShowMobileLarge,
            slidesPerGroup: slidesToScrollMobileLarge,
        },
        [MIN_SCREEN_WIDTH_TABLET_SMALL]: {
            slidesPerView: displayCroppedSlides ? slidesToShowTabletSmall + SlideCropped.SMALL : slidesToShowTabletSmall,
            slidesPerGroup: slidesToScrollTabletSmall,
        },
        [MIN_SCREEN_WIDTH_TABLET]: {
            slidesPerView: displayCroppedSlides ? slidesToShowTablet + SlideCropped.LARGE : slidesToShowTablet,
            slidesPerGroup: slidesToScrollTablet,
        },
        [MIN_SCREEN_WIDTH_DESKTOP]: {
            slidesPerView: displayCroppedSlides ? slidesToShowDesktop + SlideCropped.LARGE : slidesToShowDesktop,
            slidesPerGroup: slidesToScrollDesktop,
        },
        [MIN_SCREEN_WIDTH_DESKTOP_LARGE]: {
            slidesPerView: displayCroppedSlides ? slidesToShowDesktopLarge + SlideCropped.LARGE : slidesToShowDesktopLarge,
            slidesPerGroup: slidesToScrollDesktopLarge,
        },
    };
    const sliderCarouselConfig = {
        variant: CarouselVariant.SLIDER,
        arrowsConfig: {
            variant: SliderNavVariant.CIRCLE,
            color: SliderNavColor.BASE,
            iconSize: IconSize.MINOR,
        },
        showPagination: showIndicators,
        paginationVariant: CarouselPaginationVariant.MAIN_CLICKABLE,
        hideMobile: hideOnViewports,
        configurationOverrides: {
            autoplay,
            preventClicks: true,
            spaceBetween: slidesSpacing,
            shouldSwiperUpdate: true,
            watchOverflow: true,
            loop: infiniteSliding,
            breakpoints,
        },
    };
    if (!showArrowsForDesktop) {
        sliderCarouselConfig.configurationOverrides.navigation = false;
    }
    const getSlideWidth = (slidesPerView, spacing) => `calc((100% - ${slidesPerView - 1} * ${spacing}px) / ${slidesPerView})`;
    const getStyleFragment = () => `
        #${id}.as-m-carousel--loading .swiper-slide {
            margin-right: ${slidesSpacing}px;
        }
        @media (min-width: ${MIN_SCREEN_WIDTH_MOBILE}px) {
            #${id}.as-m-carousel--loading .swiper-slide {
                width: ${getSlideWidth(breakpoints[MIN_SCREEN_WIDTH_MOBILE].slidesPerView, slidesSpacing)};
            }
        }
        @media (min-width: ${MIN_SCREEN_WIDTH_MOBILE_LARGE}px) {
            #${id}.as-m-carousel--loading .swiper-slide {
                width: ${getSlideWidth(breakpoints[MIN_SCREEN_WIDTH_MOBILE_LARGE].slidesPerView, slidesSpacing)};
            }
        }
        @media (min-width: ${MIN_SCREEN_WIDTH_TABLET_SMALL}px) {
            #${id}.as-m-carousel--loading .swiper-slide {
                width: ${getSlideWidth(breakpoints[MIN_SCREEN_WIDTH_TABLET_SMALL].slidesPerView, slidesSpacing)};
            }
        }
        @media (min-width: ${MIN_SCREEN_WIDTH_TABLET}px) {
            #${id}.as-m-carousel--loading .swiper-slide {
                width: ${getSlideWidth(breakpoints[MIN_SCREEN_WIDTH_TABLET].slidesPerView, slidesSpacing)};
            }
        }
        @media (min-width: ${MIN_SCREEN_WIDTH_DESKTOP}px) {
            #${id}.as-m-carousel--loading .swiper-slide {
                width: ${getSlideWidth(breakpoints[MIN_SCREEN_WIDTH_DESKTOP].slidesPerView, slidesSpacing)};
            }
        }
        @media (min-width: ${MIN_SCREEN_WIDTH_DESKTOP_LARGE}px) {
            #${id}.as-m-carousel--loading .swiper-slide {
                width: ${getSlideWidth(breakpoints[MIN_SCREEN_WIDTH_DESKTOP_LARGE].slidesPerView, slidesSpacing)};
            }
        }
        ${(height === null || height === void 0 ? void 0 : height.mobile)
        ? `@media (max-width: ${MAX_SCREEN_WIDTH_TABLET_SMALL}px) {
                      #${id} .swiper-container { height: ${height.mobile}px; }
                    }`
        : ''}
        ${(height === null || height === void 0 ? void 0 : height.tablet)
        ? `@media (min-width: ${MIN_SCREEN_WIDTH_TABLET}px) and (max-width: ${MAX_SCREEN_WIDTH_TABLET}px) {
                      #${id} .swiper-container { height: ${height.tablet}px; }
                    }`
        : ''}
        ${(height === null || height === void 0 ? void 0 : height.desktop)
        ? `@media (min-width: ${MIN_SCREEN_WIDTH_DESKTOP}px) {
                      #${id} .swiper-container { height: ${height.desktop}px; }
                    }`
        : ''}
    `;
    return (_jsxs(_Fragment, { children: [_jsx(HtmlInclude, { styleFragment: getStyleFragment() }), _jsx(Carousel, Object.assign({}, sliderCarouselConfig, { id: id, fullWidth: fullWidth, children: children }))] }));
};
